import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Back from "@/assets/Back.svg";

const BackButton = () => {
  const navigate = useNavigate();
  const onClickHandler = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div onClick={onClickHandler}>
      <BackSVG name={Back} />
    </div>
  );
};

export default BackButton;

export const BackSVG = styled.div<{ name: string }>`
  background-image: url(${(props) => props.name});
  background-position: center;
  background-size: cover;
  width: 30px;
  height: 30px;
  margin: 0 1rem;
  cursor: pointer;
`;
